import styled from 'styled-components';
import { variant } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { BaseInput, Label as BaseLabel } from '../../../shared/FormStyles';

export const FormWrapper = styled.div`
  display: flex;

  @media (max-width: 900px) {
    display: block;
  }
`;

export const FormSection = styled.div`
  width: 35%;
  margin-right: 40px;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const RightSideSection = styled.div`
  width: 65%;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const InputDateWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #dbdde0;
  border-radius: 8px;
  ${variant({
    variants: {
      disabled: {
        backgroundColor: 'black.5',
      },
    },
  })};
`;

export const InputWrapper = styled.div`
  margin-top: 23px;
`;

export const Label = styled(BaseLabel)`
  margin-bottom: 8px;
  margin-top: 16px;
  margin-right: 8px;
`;

export const CustomInput = styled(BaseInput)`
  padding: 10px 16px !important;
  border: 0 !important;
  &:disabled {
    background-color: ${themeGet('colors.black.5')} !important;
  }
`;

export const LinkButton = styled.div`
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  opacity: ${props => (props.disabled ? '24%' : '100%')};
  font-weight: 600;
  font-size: 12px;
  color: ${themeGet('colors.primary.100')};
  margin-top: 17px;
  &:hover {
    opacity: 0.8;
  }
`;

export const RemoveButton = styled(LinkButton)`
  position: relative;
  top: 14px;
  left: 127px;
  z-index: 1;
`;

export const Container = styled.div`
  background-color: ${themeGet('colors.white')};
  min-height: 484px;
  margin-top: 16px;
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  padding: 0 24px 7px 24px;
`;

export const Footer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
`;
